<template>
  <div class="left-side">
    <div class="left-side-text d-none d-lg-block">
      <h3>MEDA FORTBILDUNGEN</h3>
      <p>Aus der Pflege – für die Pflege.</p>
    </div>
    <div class="left-side-main-img d-none d-lg-block">
      <img src="@/assets/images/login-left.png" />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.left-side {
  width: 40vw;
  height: 100vh;
  background: $primary-deep;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 60px 48px;

  &-text {
    text-align: center;
    margin-bottom: 48px;
    h3 {
      font-family: 'Poppins', 'ui-sans-serif', system-ui, sans-serif;
      font-weight: 700;
      font-size: 24px;
      line-height: 1.2;
      color: $white;
      letter-spacing: 0.5px;
      margin-bottom: 8px;
    }
    p {
      font-family: 'Poppins', 'ui-sans-serif', system-ui, sans-serif;
      font-weight: 400;
      font-size: 14px;
      line-height: 1.5;
      color: #CFDDE9;
      letter-spacing: 0.2px;
    }
  }

  &-main-img {
    width: 100%;
    img {
      object-fit: contain;
      width: 100%;
    }
  }
}
@media (max-width: 998px) {
  .left-side {
    display: none;
  }
}
</style>
